// import React, { useState } from "react";
// import {
// 	Container,
// 	Row,
// 	Col,
// 	Nav,
// 	NavItem,
// 	NavLink,
// 	Form,
// 	FormGroup,
// 	Label,
// 	Input,
// 	Button,
// 	Card,
// 	CardBody,
// 	Table
// } from "reactstrap";
// import { Search, Bell, User, Calendar, Zap, ChevronLeft, ChevronRight } from "react-feather";
// import "../../assets/scss/pages/admin/_toolAdmin.scss";

// interface Segment {
// 	id: string;
// 	name: string;
// 	description?: string;
// }

// interface User {
// 	id: string;
// 	name: string;
// 	email: string;
// }

// interface EmailCampaign {
// 	id: string;
// 	recipient: string;
// 	subject: string;
// 	status: "Sent" | "Scheduled" | "Draft";
// 	date: string;
// }

// interface Integration {
// 	name: string;
// 	desc: string;
// 	icon: string;
// }

// // Calendar Component
// const InlineCalendar: React.FC<{
// 	onDateSelect: (date: string) => void;
// 	onClose: () => void;
// }> = ({ onDateSelect, onClose }) => {
// 	const [currentDate, setCurrentDate] = useState(new Date());

// 	const months = [
// 		"January",
// 		"February",
// 		"March",
// 		"April",
// 		"May",
// 		"June",
// 		"July",
// 		"August",
// 		"September",
// 		"October",
// 		"November",
// 		"December"
// 	];

// 	const daysOfWeek = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

// 	const getDaysInMonth = (date: Date) => {
// 		const year = date.getFullYear();
// 		const month = date.getMonth();
// 		const firstDay = new Date(year, month, 1);
// 		const lastDay = new Date(year, month + 1, 0);
// 		const daysInMonth = lastDay.getDate();
// 		const startingDayOfWeek = firstDay.getDay();

// 		const days = [];

// 		// Add empty cells for days before the first day of the month
// 		for (let i = 0; i < startingDayOfWeek; i++) {
// 			const prevMonth = new Date(year, month - 1, 0);
// 			const prevDay = prevMonth.getDate() - startingDayOfWeek + i + 1;
// 			days.push({
// 				day: prevDay,
// 				isCurrentMonth: false,
// 				date: new Date(year, month - 1, prevDay)
// 			});
// 		}

// 		// Add days of current month
// 		for (let day = 1; day <= daysInMonth; day++) {
// 			days.push({
// 				day,
// 				isCurrentMonth: true,
// 				date: new Date(year, month, day)
// 			});
// 		}

// 		// Add days from next month to fill the grid
// 		const totalCells = Math.ceil(days.length / 7) * 7;
// 		let nextMonthDay = 1;
// 		while (days.length < totalCells) {
// 			days.push({
// 				day: nextMonthDay,
// 				isCurrentMonth: false,
// 				date: new Date(year, month + 1, nextMonthDay)
// 			});
// 			nextMonthDay++;
// 		}

// 		return days;
// 	};

// 	const handlePrevMonth = () => {
// 		setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
// 	};

// 	const handleNextMonth = () => {
// 		setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
// 	};

// 	const handleDateClick = (date: Date) => {
// 		const today = new Date();
// 		today.setHours(0, 0, 0, 0);

// 		if (date >= today) {
// 			const formattedDate = date.toISOString().split("T")[0];
// 			onDateSelect(formattedDate);
// 			onClose();
// 		}
// 	};

// 	const isToday = (date: Date) => {
// 		const today = new Date();
// 		return date.toDateString() === today.toDateString();
// 	};

// 	const isPastDate = (date: Date) => {
// 		const today = new Date();
// 		today.setHours(0, 0, 0, 0);
// 		return date < today;
// 	};

// 	const days = getDaysInMonth(currentDate);

// 	return (
// 		<div className="inline-calendar">
// 			<div className="calendar-header">
// 				<button className="calendar-nav-btn" onClick={handlePrevMonth} type="button">
// 					<ChevronLeft size={16} />
// 				</button>
// 				<h6 className="calendar-title">
// 					{months[currentDate.getMonth()]} {currentDate.getFullYear()}
// 				</h6>
// 				<button className="calendar-nav-btn" onClick={handleNextMonth} type="button">
// 					<ChevronRight size={16} />
// 				</button>
// 			</div>

// 			<div className="calendar-days-header">
// 				{daysOfWeek.map((day) => (
// 					<div key={day} className="calendar-day-header">
// 						{day}
// 					</div>
// 				))}
// 			</div>

// 			<div className="calendar-grid">
// 				{days.map((dayObj, index) => (
// 					<button
// 						key={index}
// 						className={`calendar-day ${!dayObj.isCurrentMonth ? "other-month" : ""} ${
// 							isToday(dayObj.date) ? "today" : ""
// 						} ${isPastDate(dayObj.date) ? "past-date" : ""}`}
// 						onClick={() => handleDateClick(dayObj.date)}
// 						disabled={isPastDate(dayObj.date)}
// 						type="button"
// 					>
// 						{dayObj.day}
// 					</button>
// 				))}
// 			</div>
// 		</div>
// 	);
// };

// const integrations: Integration[] = [
// 	{
// 		name: "Google Sheets",
// 		desc: "Sync customer data and reports directly to Google Sheets.",
// 		icon: "📊"
// 	},
// 	{
// 		name: "Airtable",
// 		desc: "Manage complex datasets and workflows with Airtable bases.",
// 		icon: "🗃️"
// 	},
// 	{
// 		name: "Microsoft Excel",
// 		desc: "Export and sync data with Microsoft Excel for offline analysis.",
// 		icon: "📈"
// 	},
// 	{
// 		name: "SAP",
// 		desc: "Integrate with your SAP ERP for seamless data flow.",
// 		icon: "🏢"
// 	},
// 	{
// 		name: "Salesforce",
// 		desc: "Sync customer and sales data with your Salesforce CRM.",
// 		icon: "☁️"
// 	},
// 	{
// 		name: "HubSpot",
// 		desc: "Connect marketing and sales data with your HubSpot account.",
// 		icon: "🎯"
// 	}
// ];

// const ToolAdmin: React.FC = () => {
// 	const [activeTab, setActiveTab] = useState("email-insights");
// 	const [emailForm, setEmailForm] = useState({ segmentId: "", subject: "", body: "" });
// 	const [insightForm, setInsightForm] = useState({
// 		userId: "",
// 		ingredient: "",
// 		ingredientMethod: "manual" as "manual" | "favorite"
// 	});
// 	const [generatedInsight, setGeneratedInsight] = useState<{
// 		subject: string;
// 		body: string;
// 	} | null>(null);
// 	const [integrationUser, setIntegrationUser] = useState<Record<string, string>>({});
// 	const [integrationActive, setIntegrationActive] = useState<Record<string, boolean>>({});
// 	const [showCalendar, setShowCalendar] = useState<"email" | "insight" | null>(null);
// 	const [selectedDate, setSelectedDate] = useState("");

// 	const segments: Segment[] = [
// 		{ id: "seg-1", name: "All Users" },
// 		{ id: "seg-2", name: "Trialing Customers" },
// 		{ id: "seg-3", name: "B2B Users (Enterprise)" },
// 		{ id: "seg-4", name: "Innovate Inc." }
// 	];

// 	const users: User[] = [
// 		{ id: "user-1", name: "John Doe", email: "john@example.com" },
// 		{ id: "user-2", name: "Sarah Smith", email: "sarah@example.com" },
// 		{ id: "user-3", name: "Mike Johnson", email: "mike@example.com" }
// 	];

// 	const emailHistory: EmailCampaign[] = [
// 		{
// 			id: "EML-001",
// 			recipient: "Trialing Customers",
// 			subject: "Your trial is ending soon!",
// 			status: "Sent",
// 			date: "2023-07-20"
// 		},
// 		{
// 			id: "EML-002",
// 			recipient: "B2B Users (Enterprise)",
// 			subject: "New Feature: Scenario Engine",
// 			status: "Sent",
// 			date: "2023-07-18"
// 		},
// 		{
// 			id: "EML-003",
// 			recipient: "All Users",
// 			subject: "Weekly Newsletter",
// 			status: "Scheduled",
// 			date: "2023-07-25"
// 		},
// 		{
// 			id: "EML-004",
// 			recipient: "Innovate Inc.",
// 			subject: "Insight: Açaí Pulp Price Spike",
// 			status: "Sent",
// 			date: "2023-07-24"
// 		}
// 	];

// 	const handleEmailChange = (field: keyof typeof emailForm, value: string) =>
// 		setEmailForm((prev) => ({ ...prev, [field]: value }));

// 	const handleInsightChange = (field: keyof typeof insightForm, value: string) =>
// 		setInsightForm((prev) => ({ ...prev, [field]: value }));

// 	const sendEmail = () => {
// 		if (!emailForm.segmentId || !emailForm.subject || !emailForm.body) {
// 			alert("Please fill all fields.");
// 			return;
// 		}
// 		alert(`Email sent: ${emailForm.subject}`);
// 		setEmailForm({ segmentId: "", subject: "", body: "" });
// 	};

// 	const generateInsight = () => {
// 		if (!insightForm.userId || !insightForm.ingredient) {
// 			alert("Please select user and provide ingredient.");
// 			return;
// 		}
// 		const user = users.find((u) => u.id === insightForm.userId);
// 		if (!user) return;
// 		setGeneratedInsight({
// 			subject: `Generated email subject`,
// 			body: `Generated email body...`
// 		});
// 	};

// 	const sendInsight = () => {
// 		if (!generatedInsight) return;
// 		alert("Insight email sent.");
// 		setGeneratedInsight(null);
// 		setInsightForm({ userId: "", ingredient: "", ingredientMethod: "manual" });
// 	};

// 	const handleScheduleClick = (type: "email" | "insight") => {
// 		setShowCalendar(showCalendar === type ? null : type);
// 	};

// 	const handleDateSelect = (date: string) => {
// 		setSelectedDate(date);
// 		const formattedDate = new Date(date).toLocaleDateString();
// 		alert(`${showCalendar === "email" ? "Email" : "Insight"} scheduled for ${formattedDate}`);
// 		setShowCalendar(null);
// 	};

// 	const badgeClass = (status: string) =>
// 		status === "Sent"
// 			? "badge badge-success"
// 			: status === "Scheduled"
// 			? "badge badge-warning"
// 			: "badge badge-secondary";

// 	const handleIntegrationUserChange = (integrationName: string, userId: string) => {
// 		setIntegrationUser((prev) => ({ ...prev, [integrationName]: userId }));
// 	};

// 	const handleIntegrationToggle = (integrationName: string) => {
// 		setIntegrationActive((prev) => ({ ...prev, [integrationName]: !prev[integrationName] }));
// 	};

// 	return (
// 		<div className="dashboard-container">
// <header className="dashboard-header bg-white border-bottom p-4">
// 	<div className="container-fluid d-flex justify-content-between align-items-center">
// 		<div className="position-relative search-bar" style={{ maxWidth: 480, width: "100%" }}>
// 			<Search
// 				className="position-absolute"
// 				style={{ top: 14, left: 12, color: "#aaa" }}
// 				size={19}
// 			/>
// 			<input
// 				type="text"
// 				className="form-control"
// 				placeholder="Search tools..."
// 				style={{
// 					height: 44,
// 					paddingLeft: 44,
// 					borderRadius: 10,
// 					backgroundColor: "#fafbfc",
// 					borderColor: "#e9ecef",
// 					fontSize: 17
// 				}}
// 			/>
// 		</div>
// 		<div className="d-flex align-items-center header-actions" style={{ gap: 20 }}>
// 			<button
// 				className="btn btn-link position-relative notification-btn"
// 				aria-label="Notifications"
// 				style={{ padding: 0 }}
// 			>
// 				<Bell size={24} />
// 				<span className="position-absolute notification-dot" />
// 			</button>
// 			<div
// 				className="user-avatar bg-secondary rounded-circle d-flex justify-content-center align-items-center"
// 				style={{ width: 38, height: 38 }}
// 			>
// 				<User size={20} color="#fff" />
// 			</div>
// 		</div>
// 	</div>
// </header>

// 			<Container fluid>
// 				<Row>
// 					<Col>
// 						<Nav tabs className="custom-tabs mb-4">
// 							<NavItem>
// 								<NavLink
// 									href="#"
// 									className={activeTab === "email-insights" ? "active" : ""}
// 									onClick={(e) => {
// 										e.preventDefault();
// 										setActiveTab("email-insights");
// 									}}
// 								>
// 									Email Insights
// 								</NavLink>
// 							</NavItem>
// 							<NavItem>
// 								<NavLink
// 									href="#"
// 									className={activeTab === "integrations" ? "active" : ""}
// 									onClick={(e) => {
// 										e.preventDefault();
// 										setActiveTab("integrations");
// 									}}
// 								>
// 									Integrations
// 								</NavLink>
// 							</NavItem>
// 						</Nav>

// 						{activeTab === "email-insights" && (
// 							<>
// 								<Card className="mb-5">
// 									<CardBody>
// 										<h3 className="mb-2 fw-semibold">Email Insights</h3>
// 										<p className="text-muted mb-4">Send personalized emails to your users.</p>

// 										<h5 className="mb-3 fw-semibold">New Email Campaign</h5>
// 										<Form>
// 											<Row>
// 												<Col md={6} className="mb-3">
// 													<Label for="segmentSelect">Recipient Segment</Label>
// 													<Input
// 														id="segmentSelect"
// 														type="select"
// 														value={emailForm.segmentId}
// 														onChange={(e) => handleEmailChange("segmentId", e.target.value)}
// 														style={{
// 															height: 44,
// 															borderRadius: 10,
// 															backgroundColor: "#fafbfc",
// 															fontSize: 17
// 														}}
// 													>
// 														<option value="">Select a segment</option>
// 														{segments.map((segment) => (
// 															<option key={segment.id} value={segment.id}>
// 																{segment.name}
// 															</option>
// 														))}
// 													</Input>
// 												</Col>
// 												<Col md={6} className="mb-3">
// 													<Label for="subjectInput">Subject</Label>
// 													<Input
// 														id="subjectInput"
// 														type="text"
// 														value={emailForm.subject}
// 														onChange={(e) => handleEmailChange("subject", e.target.value)}
// 														placeholder="Enter email subject"
// 														style={{
// 															height: 44,
// 															borderRadius: 10,
// 															backgroundColor: "#fafbfc",
// 															fontSize: 17
// 														}}
// 													/>
// 												</Col>
// 											</Row>
// 											<FormGroup>
// 												<Label for="bodyInput">Body</Label>
// 												<Input
// 													id="bodyInput"
// 													type="textarea"
// 													rows={6}
// 													placeholder="Compose your email..."
// 													value={emailForm.body}
// 													onChange={(e) => handleEmailChange("body", e.target.value)}
// 													style={{ borderRadius: 10, backgroundColor: "#fafbfc", fontSize: 17 }}
// 												/>
// 											</FormGroup>
// 											<div className="action-buttons">
// 												<Button color="dark" style={{ borderRadius: 10 }} onClick={sendEmail}>
// 													Send Now
// 												</Button>
// 												<div className="position-relative">
// 													<Button
// 														color="outline-secondary"
// 														style={{ borderRadius: 10 }}
// 														onClick={() => handleScheduleClick("email")}
// 													>
// 														<Calendar size={18} className="me-1" /> Schedule for later
// 													</Button>
// 													{showCalendar === "email" && (
// 														<div className="calendar-dropdown">
// 															<InlineCalendar
// 																onDateSelect={handleDateSelect}
// 																onClose={() => setShowCalendar(null)}
// 															/>
// 														</div>
// 													)}
// 												</div>
// 											</div>
// 										</Form>
// 									</CardBody>
// 								</Card>

// 								<Card className="mb-5">
// 									<CardBody>
// 										<h5 className="mb-3 fw-semibold">Personalized Ingredient Insights</h5>
// 										<Form>
// 											<Row>
// 												<Col md={6} className="mb-3">
// 													<Label for="userSelect">Select User</Label>
// 													<Input
// 														id="userSelect"
// 														type="select"
// 														value={insightForm.userId}
// 														onChange={(e) => handleInsightChange("userId", e.target.value)}
// 														style={{
// 															height: 44,
// 															borderRadius: 10,
// 															backgroundColor: "#fafbfc",
// 															fontSize: 17
// 														}}
// 													>
// 														<option value="">Select a user...</option>
// 														{users.map((user) => (
// 															<option key={user.id} value={user.id}>
// 																{user.name}
// 															</option>
// 														))}
// 													</Input>
// 												</Col>
// 												<Col md={6}>
// 													<Label>Ingredient for Insight</Label>
// 													<FormGroup>
// 														<FormGroup check inline>
// 															<Input
// 																type="radio"
// 																id="manual"
// 																name="ingredientMethod"
// 																value="manual"
// 																checked={insightForm.ingredientMethod === "manual"}
// 																onChange={(e) =>
// 																	handleInsightChange("ingredientMethod", e.target.value)
// 																}
// 															/>
// 															<Label for="manual" check>
// 																Type manually
// 															</Label>
// 														</FormGroup>
// 														<FormGroup check inline>
// 															<Input
// 																type="radio"
// 																id="favorite"
// 																name="ingredientMethod"
// 																value="favorite"
// 																checked={insightForm.ingredientMethod === "favorite"}
// 																onChange={(e) =>
// 																	handleInsightChange("ingredientMethod", e.target.value)
// 																}
// 															/>
// 															<Label for="favorite" check>
// 																Select favorite
// 															</Label>
// 														</FormGroup>
// 													</FormGroup>
// 													<Input
// 														type="text"
// 														placeholder="e.g., Açaí Pulp, Soy Protein"
// 														value={insightForm.ingredient}
// 														onChange={(e) => handleInsightChange("ingredient", e.target.value)}
// 														style={{ borderRadius: 10, backgroundColor: "#fafbfc", fontSize: 17 }}
// 													/>
// 												</Col>
// 											</Row>
// 											<Button color="outline-secondary" className="mt-3" onClick={generateInsight}>
// 												<Zap className="me-1" size={18} /> Generate Insight Email
// 											</Button>

// 											{generatedInsight && (
// 												<>
// 													<FormGroup className="mt-4">
// 														<Label>Subject</Label>
// 														<Input
// 															type="text"
// 															readOnly
// 															value={generatedInsight.subject}
// 															style={{ borderRadius: 10, backgroundColor: "#fafbfc", fontSize: 17 }}
// 														/>
// 													</FormGroup>
// 													<FormGroup>
// 														<Label>Body</Label>
// 														<Input
// 															type="textarea"
// 															readOnly
// 															rows={6}
// 															value={generatedInsight.body}
// 															style={{ borderRadius: 10, backgroundColor: "#fafbfc", fontSize: 17 }}
// 														/>
// 													</FormGroup>
// 													<div className="action-buttons">
// 														<Button color="dark" style={{ borderRadius: 10 }} onClick={sendInsight}>
// 															Send Now
// 														</Button>
// 														<div className="position-relative">
// 															<Button
// 																color="outline-secondary"
// 																style={{ borderRadius: 10 }}
// 																onClick={() => handleScheduleClick("insight")}
// 															>
// 																<Calendar className="me-1" size={18} /> Schedule for later
// 															</Button>
// 															{showCalendar === "insight" && (
// 																<div className="calendar-dropdown">
// 																	<InlineCalendar
// 																		onDateSelect={handleDateSelect}
// 																		onClose={() => setShowCalendar(null)}
// 																	/>
// 																</div>
// 															)}
// 														</div>
// 													</div>
// 												</>
// 											)}
// 										</Form>
// 									</CardBody>
// 								</Card>

// 								<Card>
// 									<CardBody>
// 										<h5 className="mb-3 fw-semibold">Email History</h5>
// 										<div className="table-responsive">
// 											<Table responsive>
// 												<thead>
// 													<tr>
// 														<th>ID</th>
// 														<th>Recipient</th>
// 														<th>Subject</th>
// 														<th>Status</th>
// 														<th>Date</th>
// 													</tr>
// 												</thead>
// 												<tbody>
// 													{emailHistory.map((email) => (
// 														<tr key={email.id}>
// 															<td>{email.id}</td>
// 															<td>{email.recipient}</td>
// 															<td>{email.subject}</td>
// 															<td>
// 																<span className={badgeClass(email.status)}>{email.status}</span>
// 															</td>
// 															<td>{email.date}</td>
// 														</tr>
// 													))}
// 												</tbody>
// 											</Table>
// 										</div>
// 									</CardBody>
// 								</Card>
// 							</>
// 						)}

// 						{activeTab === "integrations" && (
// 							<Card>
// 								<CardBody>
// 									<h3 className="mb-2 fw-semibold">Integrations</h3>
// 									<p className="text-muted mb-4">
// 										Activate and manage integrations for your users.
// 									</p>

// 									<Row>
// 										{integrations.map((integration, index) => (
// 											<Col lg={4} md={6} className="mb-4" key={index}>
// 												<div
// 													className="integration-card p-4 border rounded"
// 													style={{ borderRadius: 16 }}
// 												>
// 													<div className="d-flex align-items-start mb-3">
// 														<div
// 															className="integration-icon me-3 rounded d-flex align-items-center justify-content-center"
// 															style={{
// 																width: 48,
// 																height: 48,
// 																backgroundColor: "#f8f9fa",
// 																fontSize: "24px",
// 																flexShrink: 0
// 															}}
// 														>
// 															{integration.icon}
// 														</div>
// 														<div style={{ minWidth: 0 }}>
// 															<h5 className="mb-1 fw-semibold">{integration.name}</h5>
// 															<p className="text-muted small mb-0">{integration.desc}</p>
// 														</div>
// 													</div>

// 													<div className="mt-3">
// 														<Label className="fw-medium">Activate for User</Label>
// 														<div className="d-flex align-items-center justify-content-between mt-2 gap-2">
// 															<Input
// 																type="select"
// 																value={integrationUser[integration.name] || ""}
// 																onChange={(e) =>
// 																	handleIntegrationUserChange(integration.name, e.target.value)
// 																}
// 																style={{
// 																	borderRadius: 8,
// 																	backgroundColor: "#fafbfc",
// 																	fontSize: 14,
// 																	flex: 1,
// 																	minWidth: 0
// 																}}
// 															>
// 																<option value="">Select a user...</option>
// 																{users.map((user) => (
// 																	<option key={user.id} value={user.id}>
// 																		{user.name}
// 																	</option>
// 																))}
// 															</Input>
// 															<label className="toggle-switch">
// 																<input
// 																	type="checkbox"
// 																	checked={integrationActive[integration.name] || false}
// 																	onChange={() => handleIntegrationToggle(integration.name)}
// 																/>
// 																<span className="toggle-slider"></span>
// 															</label>
// 														</div>
// 													</div>
// 												</div>
// 											</Col>
// 										))}
// 									</Row>
// 								</CardBody>
// 							</Card>
// 						)}
// 					</Col>
// 				</Row>
// 			</Container>
// 		</div>
// 	);
// };

// export default ToolAdmin;


import React, { useState } from "react";
import {
    Container,
    Row,
    Col,
    Nav,
    NavItem,
    NavLink,
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    Card,
    CardBody,
    Table
} from "reactstrap";
import { Search, Bell, User, Calendar, Zap, ChevronLeft, ChevronRight } from "react-feather";
import { connect } from "react-redux";
import adminService from "../../services/adminService";
import "../../assets/scss/pages/admin/_toolAdmin.scss";

interface Segment {
    id: string;
    name: string;
    description?: string;
}
interface ToolAdminProps {
    fetchEmailSchedule: () => Promise<any>;
    emailTest: (email: string, name?: string, companyName?: string) => Promise<any>;
}
interface UserType {
    id: string;
    name: string;
    email: string;
}

interface EmailCampaign {
    id: string;
    recipient: string;
    subject: string;
    status: "Sent" | "Scheduled" | "Draft";
    date: string;
}

interface Integration {
    name: string;
    desc: string;
    icon: string;
}

// Calendar Component
const InlineCalendar: React.FC<{
    onDateSelect: (date: string) => void;
    onClose: () => void;
}> = ({ onDateSelect, onClose }) => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const daysOfWeek = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

    const getDaysInMonth = (date: Date) => {
        const year = date.getFullYear();
        const month = date.getMonth();
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const daysInMonth = lastDay.getDate();
        const startingDayOfWeek = firstDay.getDay();
        const days = [];

        for (let i = 0; i < startingDayOfWeek; i++) {
            const prevMonth = new Date(year, month - 1, 0);
            const prevDay = prevMonth.getDate() - startingDayOfWeek + i + 1;
            days.push({
                day: prevDay,
                isCurrentMonth: false,
                date: new Date(year, month - 1, prevDay)
            });
        }
        for (let day = 1; day <= daysInMonth; day++) {
            days.push({
                day,
                isCurrentMonth: true,
                date: new Date(year, month, day)
            });
        }
        const totalCells = Math.ceil(days.length / 7) * 7;
        let nextMonthDay = 1;
        while (days.length < totalCells) {
            days.push({
                day: nextMonthDay,
                isCurrentMonth: false,
                date: new Date(year, month + 1, nextMonthDay)
            });
            nextMonthDay++;
        }
        return days;
    };

    const handlePrevMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
    const handleNextMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
    const handleDateClick = (date: Date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (date >= today) {
            const formattedDate = date.toISOString().split("T")[0];
            onDateSelect(formattedDate);
            onClose();
        }
    };
    const isToday = (date: Date) => {
        const today = new Date();
        return date.toDateString() === today.toDateString();
    };
    const isPastDate = (date: Date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return date < today;
    };
    const days = getDaysInMonth(currentDate);

    return (
        <div className="inline-calendar">
            <div className="calendar-header">
                <button className="calendar-nav-btn" onClick={handlePrevMonth} type="button">
                    <ChevronLeft size={16} />
                </button>
                <h6 className="calendar-title">{months[currentDate.getMonth()]} {currentDate.getFullYear()}</h6>
                <button className="calendar-nav-btn" onClick={handleNextMonth} type="button">
                    <ChevronRight size={16} />
                </button>
            </div>
            <div className="calendar-days-header">
                {daysOfWeek.map(day => (
                    <div key={day} className="calendar-day-header">{day}</div>
                ))}
            </div>
            <div className="calendar-grid">
                {days.map((dayObj, index) => (
                    <button
                        key={index}
                        className={`calendar-day ${!dayObj.isCurrentMonth ? "other-month" : ""} ${isToday(dayObj.date) ? "today" : ""} ${isPastDate(dayObj.date) ? "past-date" : ""}`}
                        onClick={() => handleDateClick(dayObj.date)}
                        disabled={isPastDate(dayObj.date)}
                        type="button"
                    >
                        {dayObj.day}
                    </button>
                ))}
            </div>
        </div>
    );
};

const integrations: Integration[] = [
    { name: "Google Sheets", desc: "Sync customer data and reports directly to Google Sheets.", icon: "📊" },
    { name: "Airtable", desc: "Manage complex datasets and workflows with Airtable bases.", icon: "🗃️" },
    { name: "Microsoft Excel", desc: "Export and sync data with Microsoft Excel for offline analysis.", icon: "📈" },
    { name: "SAP", desc: "Integrate with your SAP ERP for seamless data flow.", icon: "🏢" },
    { name: "Salesforce", desc: "Sync customer and sales data with your Salesforce CRM.", icon: "☁️" },
    { name: "HubSpot", desc: "Connect marketing and sales data with your HubSpot account.", icon: "🎯" }
];


const ToolAdmin: React.FC<ToolAdminProps> = ({ fetchEmailSchedule, emailTest }) => {
    const [activeTab, setActiveTab] = useState("email-insights");
    const [emailForm, setEmailForm] = useState({ segmentId: "", subject: "", body: "" });
    const [insightForm, setInsightForm] = useState({
        userId: "",
        ingredient: "",
        ingredientMethod: "manual" as "manual" | "favorite"
    });
    const [generatedInsight, setGeneratedInsight] = useState<{ subject: string; body: string } | null>(null);
    const [integrationUser, setIntegrationUser] = useState<Record<string, string>>({});
    const [integrationActive, setIntegrationActive] = useState<Record<string, boolean>>({});
    const [showCalendar, setShowCalendar] = useState<"email" | "insight" | null>(null);
    const [selectedDate, setSelectedDate] = useState("");

    const segments: Segment[] = [
        { id: "seg-1", name: "All Users" },
        { id: "seg-2", name: "Trialing Customers" },
        { id: "seg-3", name: "B2B Users (Enterprise)" },
        { id: "seg-4", name: "Innovate Inc." }
    ];

    const users: UserType[] = [
        { id: "user-1", name: "John Doe", email: "john@example.com" },
        { id: "user-2", name: "Sarah Smith", email: "sarah@example.com" },
        { id: "user-3", name: "Mike Johnson", email: "mike@example.com" }
    ];

    const emailHistory: EmailCampaign[] = [
        { id: "EML-001", recipient: "Trialing Customers", subject: "Your trial is ending soon!", status: "Sent", date: "2023-07-20" },
        { id: "EML-002", recipient: "B2B Users (Enterprise)", subject: "New Feature: Scenario Engine", status: "Sent", date: "2023-07-18" },
        { id: "EML-003", recipient: "All Users", subject: "Weekly Newsletter", status: "Scheduled", date: "2023-07-25" },
        { id: "EML-004", recipient: "Innovate Inc.", subject: "Insight: Açaí Pulp Price Spike", status: "Sent", date: "2023-07-24" }
    ];

    const handleEmailChange = (field: keyof typeof emailForm, value: string) =>
        setEmailForm(prev => ({ ...prev, [field]: value }));

    const getNextEmailId = () => {
        const lastId = emailHistory[emailHistory.length - 1]?.id || "EML-000";
        const nextNum = parseInt(lastId.split("-")[1], 10) + 1;
        return `EML-${String(nextNum).padStart(3, "0")}`;
    };

    const handleInsightChange = (field: keyof typeof insightForm, value: string) =>
        setInsightForm(prev => ({ ...prev, [field]: value }));

    const sendEmail = async () => {
        if (!emailForm.segmentId || !emailForm.subject || !emailForm.body) {
            alert("Please fill all fields.");
            return;
        }
        // Example: get the first user's email and optional name/companyName if needed
        const recipientUser = users[0]; // or map segment to user emails as required
        if (!recipientUser) {
            alert("No user email available");
            return;
        }

        try {

            await emailTest(recipientUser.email, recipientUser.name, ""); // Pass companyName if available
            alert(`Email sent: ${emailForm.subject}`);
            setEmailForm({ segmentId: "", subject: "", body: "" });
            if (fetchEmailSchedule) {
                await fetchEmailSchedule();
            }
        } catch (error) {
            alert("Failed to send email.");
        }
    };


    const generateInsight = () => {
        if (!insightForm.userId || !insightForm.ingredient) {
            alert("Please select user and provide ingredient.");
            return;
        }
        const user = users.find(u => u.id === insightForm.userId);
        if (!user) return;
        setGeneratedInsight({
            subject: `Generated email subject`,
            body: `Generated email body...`
        });
    };

    const sendInsight = () => {
        if (!generatedInsight) return;
        alert("Insight email sent.");
        setGeneratedInsight(null);
        setInsightForm({ userId: "", ingredient: "", ingredientMethod: "manual" });
    };

    const handleScheduleClick = (type: "email" | "insight") =>
        setShowCalendar(showCalendar === type ? null : type);

    // This function triggers fetchEmailSchedule after calendar selection
    const handleDateSelect = async (date: string) => {
        setSelectedDate(date);
        const formattedDate = new Date(date).toLocaleDateString();
        alert(`${showCalendar === "email" ? "Email" : "Insight"} scheduled for ${formattedDate}`);
        setShowCalendar(null);
        if (fetchEmailSchedule) await fetchEmailSchedule(); // ← KEY INTEGRATION STEP
    };

    const badgeClass = (status: string) =>
        status === "Sent"
            ? "badge badge-success"
            : status === "Scheduled"
                ? "badge badge-warning"
                : "badge badge-secondary";

    const handleIntegrationUserChange = (integrationName: string, userId: string) =>
        setIntegrationUser(prev => ({ ...prev, [integrationName]: userId }));

    const handleIntegrationToggle = (integrationName: string) =>
        setIntegrationActive(prev => ({ ...prev, [integrationName]: !prev[integrationName] }));

    return (
        <div className="tool-admin-container">
            <header className="dashboard-header bg-white border-bottom p-4">
                <div className="container-fluid d-flex justify-content-between align-items-center">
                    <div className="position-relative search-bar" style={{ maxWidth: 480, width: "100%" }}>
                        <Search
                            className="position-absolute"
                            style={{ top: 14, left: 12, color: "#aaa" }}
                            size={19}
                        />
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search tools..."
                            style={{
                                height: 44,
                                paddingLeft: 44,
                                borderRadius: 10,
                                backgroundColor: "#fafbfc",
                                borderColor: "#e9ecef",
                                fontSize: 17
                            }}
                        />
                    </div>
                    <div className="d-flex align-items-center header-actions" style={{ gap: 20 }}>
                        <button
                            className="btn btn-link position-relative notification-btn"
                            aria-label="Notifications"
                            style={{ padding: 0 }}
                        >
                            <Bell size={24} />
                            <span className="position-absolute notification-dot" />
                        </button>
                        <div
                            className="user-avatar bg-secondary rounded-circle d-flex justify-content-center align-items-center"
                            style={{ width: 38, height: 38 }}
                        >
                            <User size={20} color="#fff" />
                        </div>
                    </div>
                </div>
            </header>
            <Container fluid>
                <Row>
                    <Col>
                        <Nav tabs className="custom-tabs mb-4">
                            <NavItem>
                                <NavLink
                                    href="#"
                                    className={activeTab === "email-insights" ? "active" : ""}
                                    onClick={e => {
                                        e.preventDefault();
                                        setActiveTab("email-insights");
                                    }}
                                >Email Insights</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    href="#"
                                    className={activeTab === "integrations" ? "active" : ""}
                                    onClick={e => {
                                        e.preventDefault();
                                        setActiveTab("integrations");
                                    }}
                                >Integrations</NavLink>
                            </NavItem>
                        </Nav>
                        {activeTab === "email-insights" && (
                            <>
                                <Card className="mb-5">
                                    <CardBody>
                                        <h3 className="mb-2 fw-semibold">Email Insights</h3>
                                        <p className="text-muted mb-4">Send personalized emails to your users.</p>
                                        <h5 className="mb-3 fw-semibold">New Email Campaign</h5>
                                        <Form>
                                            <Row>
                                                <Col md={6} className="mb-3">
                                                    <Label for="segmentSelect">Recipient Segment</Label>
                                                    <Input
                                                        id="segmentSelect"
                                                        type="select"
                                                        value={emailForm.segmentId}
                                                        onChange={e => handleEmailChange("segmentId", e.target.value)}
                                                        style={{
                                                            height: 44,
                                                            borderRadius: 10,
                                                            backgroundColor: "#fafbfc",
                                                            fontSize: 17
                                                        }}
                                                    >
                                                        <option value="">Select a segment</option>
                                                        {segments.map(segment => (
                                                            <option key={segment.id} value={segment.id}>{segment.name}</option>
                                                        ))}
                                                    </Input>
                                                </Col>
                                                <Col md={6} className="mb-3">
                                                    <Label for="subjectInput">Subject</Label>
                                                    <Input
                                                        id="subjectInput"
                                                        type="text"
                                                        value={emailForm.subject}
                                                        onChange={e => handleEmailChange("subject", e.target.value)}
                                                        placeholder="Enter email subject"
                                                        style={{
                                                            height: 44,
                                                            borderRadius: 10,
                                                            backgroundColor: "#fafbfc",
                                                            fontSize: 17
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                            <FormGroup>
                                                <Label for="bodyInput">Body</Label>
                                                <Input
                                                    id="bodyInput"
                                                    type="textarea"
                                                    rows={6}
                                                    placeholder="Compose your email..."
                                                    value={emailForm.body}
                                                    onChange={e => handleEmailChange("body", e.target.value)}
                                                    style={{ borderRadius: 10, backgroundColor: "#fafbfc", fontSize: 17 }}
                                                />
                                            </FormGroup>
                                            <div className="action-buttons">
                                                <Button color="dark" style={{ borderRadius: 10 }} onClick={sendEmail}>
                                                    Send Now
                                                </Button>
                                                <div className="position-relative">
                                                    <Button
                                                        color="outline-secondary"
                                                        style={{ borderRadius: 10 }}
                                                        onClick={() => handleScheduleClick("email")}
                                                    >
                                                        <Calendar size={18} className="me-1" /> Schedule for later
                                                    </Button>
                                                    {showCalendar === "email" && (
                                                        <div className="calendar-dropdown">
                                                            <InlineCalendar
                                                                onDateSelect={handleDateSelect}
                                                                onClose={() => setShowCalendar(null)}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </Form>
                                    </CardBody>
                                </Card>
                                <Card>
                                    <CardBody>
                                        <h5 className="mb-3 fw-semibold">Email History</h5>
                                        <div className="table-responsive">
                                            <Table responsive>
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Recipient</th>
                                                        <th>Subject</th>
                                                        <th>Status</th>
                                                        <th>Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {emailHistory.map(email => (
                                                        <tr key={email.id}>
                                                            <td>{email.id}</td>
                                                            <td>{email.recipient}</td>
                                                            <td>{email.subject}</td>
                                                            <td>
                                                                <span className={badgeClass(email.status)}>{email.status}</span>
                                                            </td>
                                                            <td>{email.date}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </CardBody>
                                </Card>
                            </>
                        )}
                        {activeTab === "integrations" && (
                            <Card>
                                <CardBody>
                                    <h3 className="mb-2 fw-semibold">Integrations</h3>
                                    <p className="text-muted mb-4">Activate and manage integrations for your users.</p>
                                    <Row>
                                        {integrations.map((integration, index) => (
                                            <Col lg={4} md={6} className="mb-4" key={index}>
                                                <div className="integration-card p-4 border rounded" style={{ borderRadius: 16 }}>
                                                    <div className="d-flex align-items-start mb-3">
                                                        <div className="integration-icon me-3 rounded d-flex align-items-center justify-content-center" style={{ width: 48, height: 48, backgroundColor: "#f8f9fa", fontSize: "24px", flexShrink: 0 }}>
                                                            {integration.icon}
                                                        </div>
                                                        <div style={{ minWidth: 0 }}>
                                                            <h5 className="mb-1 fw-semibold">{integration.name}</h5>
                                                            <p className="text-muted small mb-0">{integration.desc}</p>
                                                        </div>
                                                    </div>
                                                    <div className="mt-3">
                                                        <Label className="fw-medium">Activate for User</Label>
                                                        <div className="d-flex align-items-center justify-content-between mt-2 gap-2">
                                                            <Input
                                                                type="select"
                                                                value={integrationUser[integration.name] || ""}
                                                                onChange={e => handleIntegrationUserChange(integration.name, e.target.value)}
                                                                style={{
                                                                    borderRadius: 8,
                                                                    backgroundColor: "#fafbfc",
                                                                    fontSize: 14,
                                                                    flex: 1,
                                                                    minWidth: 0
                                                                }}
                                                            >
                                                                <option value="">Select a user...</option>
                                                                {users.map(user => (
                                                                    <option key={user.id} value={user.id}>{user.name}</option>
                                                                ))}
                                                            </Input>
                                                            <label className="toggle-switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={integrationActive[integration.name] || false}
                                                                    onChange={() => handleIntegrationToggle(integration.name)}
                                                                />
                                                                <span className="toggle-slider"></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                </CardBody>
                            </Card>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

// The schedule API action mapped here
const mapDispatchToProps = {
    fetchEmailSchedule: () => adminService.getEmailSchedule(),
    emailTest: (email: string, name?: string, companyName?: string) =>
        adminService.emailTest(email, name, companyName)
};

export default connect(null, mapDispatchToProps)(ToolAdmin);
